import PersonViewModel from "../personViewModel";
import NaturalPerson from "../../../../models/naturalPerson";
import LocalizationService from "../../../../services/localizationService";
import { interfaces } from "inversify";

export default class NaturalPersonViewModel extends PersonViewModel {
  constructor(public person: NaturalPerson, protected localizationService: LocalizationService, public showBirthdate: boolean) {
    super(person, localizationService);
  }

  static Factory({ container }: interfaces.Context) {
    return (person: NaturalPerson, showBirthdate = true) =>
      new NaturalPersonViewModel(person, container.get(LocalizationService), showBirthdate);
  }
}
